<template>
    <div class="shop__addresses">
        <div class="shop__address-block" style="padding-top: 0">
            <div class="shop__address-block-title">{{WETitle}}</div>
            <SelectWithLabel v-model="SelectedWEAddressId" :label="Strings['Shop.LabelPickAddress']" rules="required" v-show="WEDropdownVisible" :options="AvailableWEAddresses" />
            <div class="shop__address-block-spacer-small" v-if="WEDropdownVisible"></div>
            <ShopEditableAddress v-if="CurrentPosition.warenempfaenger"
                                 :address="CurrentPosition.warenempfaenger"
                                 :key="CurrentPosition.warenempfaenger_id"
                                 :showCumulus="CurrentPosition.regulierer === null && MigrosLoginAG === null"
                                 :showEmail="CurrentPosition.regulierer === null && MigrosLoginAG === null"
                                 @fixAddress="fixWE" />
            <div class="shop__addresses-separate-billing" v-if="!MigrosLoginAG">
                <Checkbox :label="Strings['Shop.Checkbox_SnA_WESeparateBillingAddress']" v-model="separateBillingAddress" />
            </div>
            <div v-if="ShowMoreUPFormText" class="shop__more-unloadingpoints">
                <v-runtime-template :template="InfoMoreThanOneUnloadingPointSnA" />
            </div>
        </div>
        <hr v-if="MigrosLoginAG" />
        <div class="shop__address-block" v-if="MigrosLoginAG">
            <div class="shop__address-block-title">{{AGTitle}}</div>
            <ShopEditableAddress :address="MigrosLoginAG"
                                 @fixAddress="fixAG"
                                 :showCumulus="!separateBillingAddress" />
            <div class="shop__addresses-separate-billing">
                <Checkbox :label="Strings['Shop.CheckboxAGSeparateBillingAddress']" v-model="separateBillingAddress" />
            </div>
        </div>
        <hr v-if="separateBillingAddress" />
        <div class="shop__address-block" v-if="separateBillingAddress">
            <div class="shop__address-block-title">{{Strings['Shop.BillingAddress']}}</div>
            <SelectWithLabel v-model="SelectedRGAddressId" :label="Strings['Shop.LabelPickAddress']" rules="required" v-show="RGDropdownVisible" :options="AvailableRGAddresses" />
            <div class="shop__address-block-spacer-small" v-if="CurrentPosition.regulierer"></div>
            <ShopEditableAddress v-if="CurrentPosition.regulierer"
                                 :key="CurrentPosition.regulierer_id"
                                 :address="CurrentPosition.regulierer"
                                 :showEmail="MigrosLoginAG === null"
                                 :showCumulus="true"
                                 @fixAddress="fixRG" />
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { AddressSource } from '@/utils/constants'
    import { clone } from '@/utils/utils'
    import Position from '@/models/Position'
    import Address from '@/models/Address'
    import Transaction from '@/models/Transaction'
    import ShopEditableAddress from './ShopEditableAddress'
    import VRuntimeTemplate from 'v-runtime-template'

    export default {
        data() {
            return {
                SelectedWEAddressId: '',
                CustomWEAddressId: -1,
                SelectedRGAddressId: '',
                CustomRGAddressId: -1,
                separateBillingAddress: false
            }
        },
        computed: {
            ...mapState([
                'MoreUPFormUrl',
                'Strings',
                'Enums'
            ]),
            WETitle() {
                if (this.MigrosLoginAG) {
                    return this.Strings['Shop.DeliveryAddress_SnA'];
                } else {
                    return this.separateBillingAddress ? this.Strings['Shop.DeliveryAddress_SnA'] : this.Strings['Shop.DeliveryAndBillingAddress_SnA'];
                }
            },
            AGTitle() {
                return this.separateBillingAddress ? this.Strings['Shop.Auftraggeber'] : this.Strings['Shop.AuftraggeberAndBillingAddress'];
            },
            CurrentTransaction() {
                return Transaction.query().with('auftraggeber').first();
            },
            CurrentPosition() {
                return Position.query().with('warenempfaenger|regulierer').where('transaction_id', this.CurrentTransaction.id).first();
            },
            AvailableWEAddresses() {
                let options = Address
                    .query()
                    .where((address) => {
                        return (
                            (address.addressSource === AddressSource.ServerAddress || address.addressSource === AddressSource.MigrosLoginAddress)
                            && address.isWarenempfaenger === true
                        );
                    })
                    .orderBy('id')
                    .get()
                    .map((addr) => { return { text: addr.dropdown_name, id: String(addr.id) } });

                options.push({ text: this.Strings['Shop.OptionOtherAddress'], id: '-1' });

                return options;
            },
            AvailableRGAddresses() {
                let options = Address
                    .query()
                    .where((a) => {
                        return (
                            a.addressSource == AddressSource.ServerAddress //only server addresses
                            && a.id != this.CurrentTransaction.auftraggeber_id //but not the current AG
                            && a.isRegulierer === true //only RG
                        );
                    })
                    .orderBy('id')
                    .get()
                    .map((addr) => { return { text: addr.dropdown_name, id: String(addr.id) } });

                options.push({ text: this.Strings['Shop.OptionOtherAddress'], id: '-1' });

                return options;
            },
            WEDropdownVisible() {
                //only show dropdown when there is more than 2 options (empty option and "other" option don't count)
                return this.AvailableWEAddresses.length > 2;
            },
            RGDropdownVisible() {
                //only show dropdown when there is more than 2 options (empty option and "other" option don't count)
                return this.AvailableRGAddresses.length > 2;
            },
            MigrosLoginAG() {
                return Address.query().where('isAuftraggeber', true).first();
            },
            ShowMoreUPFormText() {
                return this.MoreUPFormUrl != null && this.MoreUPFormUrl != '';
            },
            InfoMoreThanOneUnloadingPointSnA() {
                return '<span>' + this.Strings['Shop.InfoMoreThanOneUnloadingPointSnA'] + '</span>';
            }
        },
        watch: {
            //update WE address on pos
            SelectedWEAddressId(newValue) {
                //if the value is -1 then we take the custom address id for the update, otherwise the value of the selected entry
                let newWE = Address.find(newValue === '-1' ? this.CustomWEAddressId : newValue);
                Position.update({
                    id: this.CurrentPosition.id,
                    warenempfaenger: newWE
                }).then(() => {
                    if (this.separateBillingAddress === false) {
                        this.setWEasAG();
                    }
                });
            },
            //update RG address on pos
            SelectedRGAddressId(newValue) {
                //if the value is -1 then we take the custom address id for the update, otherwise the value of the selected entry
                let newRG = Address.find(newValue === '-1' ? this.CustomRGAddressId : newValue);
                Position.update({
                    id: this.CurrentPosition.id,
                    regulierer: newRG
                }).then(this.setRGasAG);
            },
            separateBillingAddress(newValue) {
                if (newValue === false) {
                    //remove RG from position
                    Position.update({
                        id: this.CurrentPosition.id,
                        regulierer_id: null,
                        regulierer: null
                    }).then(this.setWEasAG);
                } else {
                    //auto-select -1, if there are no server addresses available
                    if (!this.RGDropdownVisible) {
                        this.SelectedRGAddressId = '-1';
                        Position.update({
                            id: this.CurrentPosition.id,
                            regulierer: Address.find(this.CustomRGAddressId)
                        }).then(this.setRGasAG);
                    }
                }
            }
        },
        methods: {
            setRGasAG() {
                if (this.MigrosLoginAG === null) {
                    //set RG as AG
                    Transaction.update({
                        id: this.CurrentTransaction.id,
                        auftraggeber: this.CurrentPosition.regulierer
                    });
                }
            },
            setWEasAG() {
                if (this.MigrosLoginAG === null) {
                    //set WE as AG
                    Transaction.update({
                        id: this.CurrentTransaction.id,
                        auftraggeber: this.CurrentPosition.warenempfaenger
                    });
                }
            },
            fixWE() {
                //clone the WE
                let newWE = clone(this.CurrentPosition.warenempfaenger);
                delete newWE.id; //remove id (will be autogenerated on insert)
                newWE.isAuftraggeber = false; //not AG anymore
                newWE.customerId = ''; //reset customerId
                newWE.addressSource = AddressSource.ManualAddress; //make a manual address out of it

                Address
                    .insert({ data: newWE })
                    .then((createdData) => {
                        Position.update({
                            id: this.CurrentPosition.id,
                            warenempfaenger: createdData.addresses[0]
                        });
                    });
            },
            fixRG() {
                //clone the RG
                let newRG = clone(this.CurrentPosition.regulierer);
                delete newRG.id; //remove id (will be autogenerated on insert)
                newRG.isAuftraggeber = false; //not AG anymore
                newRG.customerId = ''; //reset customerId
                newRG.addressSource = AddressSource.ManualAddress; //make a manual address out of it

                Address
                    .insert({ data: newRG })
                    .then((createdData) => {
                        Position.update({
                            id: this.CurrentPosition.id,
                            regulierer: createdData.addresses[0]
                        });
                    });
            },
            fixAG() {
                //clone AG
                let newAG = clone(this.CurrentTransaction.auftraggeber);
                delete newAG.id; //remove id (will be autogenerated on insert)
                newAG.customerId = ''; //reset customerId
                newAG.addressSource = AddressSource.ManualAddress; //make a manual address out of it

                //change the "old" auftraggeber's "isAuftraggeber" flag to false
                if (this.CurrentTransaction.auftraggeber.isAuftraggeber === true) {
                    Address.update({
                        id: this.CurrentTransaction.auftraggeber.id,
                        isAuftraggeber: false
                    });
                }

                //now update the transaction to use the new AG
                Address.insert({ data: newAG })
                    .then((createdData) => {
                        Transaction.update({
                            id: this.CurrentTransaction.id,
                            auftraggeber: createdData.addresses[0]
                        });
                    });
            }
        },
        mounted() {
            let vm = this;

            if (vm.CurrentPosition.warenempfaenger !== null) {
                if (vm.CurrentPosition.warenempfaenger.isServerAddress === true || vm.CurrentPosition.warenempfaenger.isMigrosLoginAddress) {
                    vm.SelectedWEAddressId = String(vm.CurrentPosition.warenempfaenger.id);
                    //add a blank manual address, if the user later picks "other"
                    Address.new().then((newAddress) => {
                        vm.CustomWEAddressId = newAddress.id;
                    });
                } else {
                    vm.CustomWEAddressId = vm.CurrentPosition.warenempfaenger.id;
                    vm.SelectedWEAddressId = '-1';
                }
            } else {
                //create a new empty custom WE
                Address.new().then((newAddress) => {
                    vm.CustomWEAddressId = newAddress.id;
                    if (!vm.WEDropdownVisible) {
                        vm.SelectedWEAddressId = '-1';
                    }
                });
            }

            if (vm.CurrentPosition.regulierer !== null) {
                vm.separateBillingAddress = true;
                if (vm.CurrentPosition.warenempfaenger.isServerAddress === true || vm.CurrentPosition.warenempfaenger.isMigrosLoginAddress) {
                    vm.$nextTick(() => {
                        vm.SelectedRGAddressId = String(vm.CurrentPosition.regulierer.id);
                    });
                    //add a blank manual address, if the user later picks "other"
                    Address.new().then((newAddress) => {
                        vm.CustomRGAddressId = newAddress.id;
                    });
                } else {
                    vm.CustomRGAddressId = vm.CurrentPosition.regulierer.id;
                    vm.$nextTick(() => {
                        vm.SelectedRGAddressId = '-1';
                    });
                }
            }
            else {
                //create a new empty custom RG
                Address.new().then((newAddress) => {
                    vm.CustomRGAddressId = newAddress.id;
                });
            }

            if (vm.CurrentTransaction.auftraggeber === null) {
                if (vm.CurrentPosition.regulierer !== null) {
                    vm.setRGasAG();
                } else {
                    vm.setWEasAG();
                }
            }
        },
        components: {
            VRuntimeTemplate,
            ShopEditableAddress
        }
    };
</script>